export const spreadsheetsES = {
  "There no individual spreadsheets to display": "There no individual spreadsheets to display",
  "New Spreadsheet": "New Spreadsheet",
  "Actions": "Actions",
  "Format Name": "Format Name",
  "Description": "Description",
  "Folder": "Folder",
  "Modified By": "Modified By",
  "Date Modified": "Date Modified",
  "Created By": "Created By",
  "Date Created": "Date Created",
  "Run Spreadsheet": "Run Spreadsheet",
  "Edit Spreadsheet": "Edit Spreadsheet",
  "Delete Spreadsheet": "Delete Spreadsheet",
  "Are you sure you want to delete the selected format?": "Are you sure you want to delete the selected format?",
  'Delete Format': 'Delete Format',
  'Cancel': 'Cancel',
  'Query (Optional)': 'Query (Optional)',
  'Sort (Optional)': 'Sort (Optional)',
  'Columns': 'Columns',
  'Are you sure you wish to remove all fields?': 'Are you sure you wish to remove all fields?',
  'Are you sure you wish to remove all sort fields?': 'Are you sure you wish to remove all sort fields?',
  'Direction': 'Direction',
  'Ascending': 'Ascending',
  'Descending': 'Descending',
  'Failed to save formats': 'Failed to save formats',
  'This field is required': 'Este campo es obligatorio',
  'Missing required data for upload. Please ensure all required fields are available.': 'Faltan datos obligatorios para la carga. Asegúrese de que todos los campos obligatorios estén disponibles.',
  'Information Message': 'Mensaje informativo',
  'Number field accepts numeric values only, please re-try.': 'El campo numérico solo acepta valores numéricos, inténtelo de nuevo.',
  'Invalid number': 'Número no válido',
  'Upload Error': 'Error de carga',
  'Confirmation message': 'Mensaje de confirmación',
  'Upload Success': 'Carga exitosa',
  'Overwrite failed': 'Error al sobrescribir',
  'Overwrite': 'Sobrescribir',
  'File upload failed. Please try again.': 'La carga del archivo falló. Inténtelo de nuevo.',
  'File type not allowed: {fileName}': 'Tipo de archivo no permitido: {fileName}',
  'File "{fileName}" already exists. Overwrite?': 'El archivo "{fileName}" ya existe. ¿Desea sobrescribirlo?',
  'File "{fileName}" uploaded successfully.': 'El archivo "{fileName}" se cargó correctamente.',
  'Browse to {value}': 'Ir a {value}',
  'Open': 'Abrir',
  'Download': 'Descargar',
  'Click to view full image for {value}': 'Haga clic para ver la imagen completa de {value}',
  'Upload Image': 'Subir imagen',
  'Upload Document': 'Subir documento',
  'Yes (Y)': 'Sí (Y)',
  'No (N)': 'No (N)',
};